import React, { useId } from 'react';

import { FormProvider } from 'react-hook-form';

import { Button } from 'components/DesignSystem/Button';
import { Modal } from 'components/DesignSystem/Modal';
import { useRunQsraFormLogic } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm.logic';
import classes from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm.module.scss';
import { useRunQsraFormProvider } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm.provider';
import { NumberOfSimulations } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/components/NumberOfSimulations/NumberOfSimulations';
import { TargetActivity } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/components/TargetActivity/TargetActivity';

interface Props {
    latestVersionId: number;
    riskIds: number[];
    onClose: () => void;
    open: boolean;
}

export interface FormProps {
    numOfSimulations: number;
    riskIds: number[];
    metaDataId: number;
    taskVersionHashCode: string | null;
    taskVersionLabel: string | null;
    period: 'DAY' | 'WEEK';
}

export const RunQsraForm = ({ open, riskIds, latestVersionId, onClose }: Props) => {
    const { api } = useRunQsraFormProvider();
    const { logic } = useRunQsraFormLogic({ api, riskIds, latestVersionId });
    const runQsraFormId = useId();

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={'Run QSRA'}
            actions={
                <>
                    <Button size={'large'} variant={'secondary'} onClick={onClose}>
                        Cancel
                    </Button>

                    <Button
                        type={'submit'}
                        form={runQsraFormId}
                        size={'large'}
                        variant={'primary'}
                        isLoading={api.runQsraAnalysis.instance.isLoading || logic.isRunningQsra}
                        disabled={api.runQsraAnalysis.instance.isLoading || logic.isRunningQsra}
                    >
                        Run!
                    </Button>
                </>
            }
        >
            <FormProvider {...logic.form}>
                <div className={classes.runQsraForm}>
                    <form
                        id={runQsraFormId}
                        onSubmit={logic.form.handleSubmit(logic.handleSaveUseForm)}
                        autoComplete={'off'}
                    >
                        <NumberOfSimulations />
                        <TargetActivity />
                    </form>
                </div>
            </FormProvider>
        </Modal>
    );
};
